import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const deleteBarcodeLabelTemplate = {
  name: "deleteBarcodeLabelTemplate" as const,
  input: z.object({ templateId: zExt.objectId() }),
  output: z.object({}),
};
